import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    height: '100%',
    textAlign: 'center',
    '& > h2': {
      fontSize: defaultTheme.font.size.l,
      color: defaultTheme.color.secondary,
      fontWeight: 'bold',
    },
    '& > p': {
      fontSize: defaultTheme.font.size.s,
      color: defaultTheme.color.secondary,
      marginTop: defaultTheme.spacing.xxl,
      marginBottom: defaultTheme.spacing.l,
    },
  }),
);

export const ImageToretaPlusContainer = styled.div(() =>
  mq({
    width: ['108px', '108px', '108px', '108px'],
    margin: '0 auto',
  }),
);

export const ImageChargeContainer = styled.div(() =>
  mq({
    width: ['295px', '295px', '295px', '295px'],
    margin: '0 auto',
  }),
);

export const SpBr = styled.br(() =>
  mq({ display: ['none', 'none', 'none', 'none'] }),
);
